package com.parmartechnologies.communication.core.conversation.repository

import com.parmartechnologies.core.feature.auth.model.FriendlyProfile
import com.parmartechnologies.core.feature.chat.conversation.model.Conversation
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.Job
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.launch
import kotlin.time.ExperimentalTime

class ConversationRepository {

    val searchQueryState: MutableStateFlow<String> = MutableStateFlow("")
    val searchQuery: StateFlow<String>
        get() = searchQueryState

    val allConversationLiveData: MutableStateFlow<ArrayList<Conversation>> = MutableStateFlow(arrayListOf())
    val allConversation: StateFlow<ArrayList<Conversation>>
        get() = allConversationLiveData

    @OptIn(ExperimentalTime::class)
    val ConversationLiveData: MutableStateFlow<Conversation?> = MutableStateFlow(Conversation())
    val Conversation: StateFlow<Conversation?>
        get() = ConversationLiveData

    @OptIn(ExperimentalTime::class)
    val newConversationLiveData: MutableStateFlow<Conversation> = MutableStateFlow(Conversation())
    val newConversation: StateFlow<Conversation>
        get() = newConversationLiveData

    val selectedConversationState: MutableStateFlow<Conversation?> = MutableStateFlow(null)
    val selectedConversation: StateFlow<Conversation?>
        get() = selectedConversationState

    private val editConversationState: MutableStateFlow<Conversation?> = MutableStateFlow(null)
    val editConversation: StateFlow<Conversation?>
        get() = editConversationState

    @OptIn(ExperimentalTime::class)
    val profileLiveData: MutableStateFlow<FriendlyProfile?> = MutableStateFlow(FriendlyProfile())
    val profile: StateFlow<FriendlyProfile?>
        get() = profileLiveData

    fun setEditConversation(Conversation: Conversation?) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            editConversationState.emit(Conversation)
        }
    }

    fun selectConversation(Conversation: Conversation?) {
        CoroutineScope(Job() + Dispatchers.Default).launch {
            ConversationLiveData.emit(Conversation)
        }
    }

}